















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ProjectSelector from '@/components/Selects/ProjectSelector.vue';
import CorporationSelector from '@/components/Selects/CorporationSelector.vue';
import axios from 'axios';
import { isEqual } from 'lodash';
import { Endpoints } from '@/ts/store/Constants';

@Component({
    components: {
        ProjectSelector,
        CorporationSelector,
    },
})

export default class CopyKnowledgeBaseCard extends Vue {
    @Prop({ default: [] }) public readonly corporations: any;
    @Prop({ default: [] }) public readonly projects: any;

    public submittingCopyObject = false;

    public knowledgeBaseCopyObject: any = {
        selectedCorporation: null,
        sourceProject: null,
        targetProject: null,
        updateExisting: true,
    };

    get filteredProjects() {
        if (this.knowledgeBaseCopyObject.selectedCorporation) {
            return this.projects.filter((project: any) => {
                return project.corporation_id === this.knowledgeBaseCopyObject.selectedCorporation.id;
            });
        }
        return this.projects;
    }

    get availableFromProjects() {
        if (this.knowledgeBaseCopyObject.targetProject) {
            return this.filteredProjects.filter((project: any) => project.id !== this.knowledgeBaseCopyObject.targetProject.id);
        }
        return this.filteredProjects;
    }

    get availableToProjects() {
        if (this.knowledgeBaseCopyObject.sourceProject) {
            return this.filteredProjects.filter((project: any) => project.id !== this.knowledgeBaseCopyObject.sourceProject.id);
        }
        return this.filteredProjects;
    }

    get canSubmitKnowledgeBaseCopy() {
        return (this.knowledgeBaseCopyObject.sourceProject !== null && this.knowledgeBaseCopyObject.targetProject !== null);
    }

    @Watch('knowledgeBaseCopyObject.selectedCorporation')
    public onCopyObjectCorporationChange(val: any, oldVal: any) {
        if (!isEqual(val, oldVal)) {
            this.knowledgeBaseCopyObject.sourceProject = null;
            this.knowledgeBaseCopyObject.targetProject = null;
        }
    }

    public resetKnowledgeBaseCopyObject() {
        this.knowledgeBaseCopyObject = {
            selectedCorporation: null,
            sourceProject: null,
            targetProject: null,
            updateExisting: true,
        };
    }

    public submitKnowledgeBaseCopy() {
        const requestData = {
            sourceProjectId: this.knowledgeBaseCopyObject.sourceProject.id,
            targetProjectId: this.knowledgeBaseCopyObject.targetProject.id,
            updateExisting: this.knowledgeBaseCopyObject.updateExisting,
        };
        this.submittingCopyObject = true;
        axios.post(Endpoints.Neckbeard.COPY_KNOWLEDGE_BASE, requestData)
            .then(() => {
                this.submittingCopyObject = false;
                this.resetKnowledgeBaseCopyObject();
                console.log('Succesful knowledge base copy');

            })
            .catch((error) => {
                this.submittingCopyObject = false;
                console.log('Error knowledge base copy');
                console.log(error);
            });
    }
}
